export const selectReducer = (state) => state.userProfile;

export const selectIsLoading = (state) =>
  selectReducer(state).get('isLoading') || false;

export const selectUserProfile = (state) =>
  selectReducer(state).get('data') || {};
